import React, { useState } from 'react';
import Modal from 'react-modal';

interface ApprovalModalProps {
    timesheetCount: number;
    onClose: () => void;
    onSubmit: () => void;
    isSubmitting?: boolean;
}

const ApprovalModal: React.FC<ApprovalModalProps> = ({
    timesheetCount,
    onClose,
    onSubmit,
    isSubmitting = false,
}) => {
    const [isAccepted, setIsAccepted] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!isAccepted) {
            return;
        }

        onSubmit();
    };

    const timesheetText = timesheetCount === 1 ? 'timesheet' : 'timesheets';

    return (
        <Modal
            className="approval-modal"
            isOpen={true}
            onRequestClose={onClose}
            contentLabel="Authorisation and Acceptance Declaration"
            ariaHideApp={false}
        >
            <form onSubmit={handleSubmit}>
                <div className="modal-body">
                    <p className="approval-modal__description">
                        You are about to approve {timesheetCount} {timesheetText}. Please review and accept the
                        declaration below to proceed.
                    </p>

                    <div className="form-group">
                        <label className="approval-modal__checkbox-label">
                            <input
                                type="checkbox"
                                checked={isAccepted}
                                onChange={e => setIsAccepted(e.target.checked)}
                                disabled={isSubmitting}
                                className="approval-modal__checkbox"
                            />
                            <span className="approval-modal__checkbox-text">
                                By ticking this box, I hereby:
                            </span>
                        </label>

                        <ul className="approval-modal__declaration-list">
                            <li>Confirm my authority to approve the hours submitted on this timesheet.</li>
                            <li>Verify the accuracy of the total hours worked as recorded.</li>
                            <li>
                                Acknowledge and agree that all assignments approved herein, and any future
                                assignments, shall be governed by Berry Recruitment&apos;s Terms and Conditions of
                                Business, which are available at{' '}
                                <a
                                    href="https://www.berryrecruitment.co.uk"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    www.berryrecruitment.co.uk
                                </a>
                                .
                            </li>
                            <li>Accept that electronic approval constitutes a legally binding signature</li>
                        </ul>
                    </div>
                </div>

                <div className="modal-bottom-bar">
                    <button
                        type="submit"
                        className="table-action-button"
                        disabled={!isAccepted || isSubmitting}
                    >
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                    <button
                        type="button"
                        className="table-action-button table-action-button-secondary"
                        onClick={onClose}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default ApprovalModal;

